<div class="container">
    <div class="stroke-all-input-container">
        <div class="input-wrapper">
            <mat-icon class="icon" svgIcon="stroke-size"></mat-icon>
            <input
                #input
                type="number"
                [(ngModel)]="strokeWidth"
                [type]="strokeWidth == MIXED_STRING ? 'text' : 'number'"
                (blur)="setStrokeWidthElem()"
                (keydown)="validStrokeKeyDown($event)"
                (keydown.enter)="setStrokeWidthElem()" />
            <mat-icon class="icon" svgIcon="stroke-all"></mat-icon>
        </div>
    </div>

    <div class="stroke-style-container" *ngIf="!connectorType">
        <span class="title">{{ 'mimic-drawing.stroke-style' | translate }}</span>
        <div class="stroke-style" [class.show]="showingStyleList" (click)="openStyleList($event)">
            <div class="text-container">
                <mat-icon [svgIcon]="strokeStyle"></mat-icon>
            </div>
            <mat-icon class="dropdown-icon" [class.show]="showingStyleList" svgIcon="arrow-down"></mat-icon>
        </div>
        <ul class="item-list" *ngIf="showingStyleList" #styleList>
            <li
                class="item-stroke-style"
                (click)="handleStyleChange(lineStyleItem)"
                *ngFor="let lineStyleItem of LINE_STYLE_LIST; index as i">
                <mat-icon class="select-icon" [class.show]="lineStyleItem === strokeStyle" svgIcon="check"></mat-icon>
                <mat-icon [svgIcon]="lineStyleItem"></mat-icon>
            </li>
        </ul>
    </div>

    <div class="line-join-container" *ngIf="!connectorType">
        <span class="title">{{ 'mimic-drawing.line-join' | translate }}</span>
        <ul class="line-join-style">
            <li
                class="item-line-join"
                [class.select]="lineJoinStyleItem === joinStyle"
                (click)="handleJoinChange(lineJoinStyleItem)"
                *ngFor="let lineJoinStyleItem of LINE_JOIN_STYLE_LIST; index as i"
                [matTooltip]="getTooltip(lineJoinStyleItem) | translate">
                <mat-icon [svgIcon]="lineJoinStyleItem"></mat-icon>
            </li>
        </ul>
    </div>
</div>
